import React, { useContext, useState } from 'react'
import './Home.css'
import image from '../image/image.png'
import send from '../image/send.png'
import { AuthContext } from '../../context/AuthContext'
import { ChatContext } from '../../context/ChatContext'
import { Timestamp, arrayUnion, doc, updateDoc } from 'firebase/firestore'
import { db, storage } from '../../config'
import { v4 as uuid } from 'uuid'
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage'

const Input = () => {
  const [text, setText] = useState('')
  const [img, setImg] = useState(null)

  const { curUser } = useContext(AuthContext)
  const { data } = useContext(ChatContext)

  const handleSend = async () => {
    if (img) {
      const storageRef = ref(storage, uuid())
      const uploadTask = uploadBytesResumable(storageRef, img)

      uploadTask.on(
        (error) => {},
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
            await updateDoc(doc(db, 'groups', data.groupId), {
              message: arrayUnion({
                id: uuid(),
                text,
                sender: curUser.displayName,
                img: downloadURL,
                date: Timestamp.now(),
              }),
            })
          })
        },
      )
    } else if (text) {
      await updateDoc(doc(db, 'groups', data.groupId), {
        message: arrayUnion({
          id: uuid(),
          text,
          sender: curUser.displayName,
          date: Timestamp.now(),
        }),
      })
    }

    setText('')
    setImg(null)
  }

  const handleEnter = (e) => {
    if (e.code === 'Enter') {
      try {
        ;(text || img) && handleSend()
      } catch (err) {
        console.log(err.message)
      }
    }
  }

  return (
    <div className="input">
      <input
        type="text"
        placeholder="Aa"
        className="inputPool"
        onChange={(e) => setText(e.target.value)}
        value={text}
        onKeyDown={handleEnter}
      />
      <div className="sendIcon">
        <input
          type="file"
          style={{ display: 'none' }}
          id="file"
          onChange={(e) => setImg(e.target.files[0])}
          onKeyDown={handleEnter}
        />
        <label htmlFor="file">
          <img
            src={image}
            alt=""
            width={'100px'}
            height={'100px'}
            className="addfile"
          />
        </label>
        <button className="sendButton" onClick={handleSend}>
          <img src={send} alt="" width={'80px'} height={'80px'} />
        </button>
      </div>
    </div>
  )
}

export default Input
